var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient } from '../interceptor/interceptor';
const legalDocumentPdfCache = new Map();
const legalDocumentPdfRequests = new Map();
const legalDocumentContentCache = new Map();
const legalDocumentContentRequests = new Map();
export const getLegalDocumentPDF = (documentType_1, ...args_1) => __awaiter(void 0, [documentType_1, ...args_1], void 0, function* (documentType, locale = 'en-US') {
    const cacheKey = `${documentType}:${locale}`;
    const cachedDocument = legalDocumentPdfCache.get(cacheKey);
    if (cachedDocument) {
        return cachedDocument;
    }
    const pendingRequest = legalDocumentPdfRequests.get(cacheKey);
    if (pendingRequest) {
        return pendingRequest;
    }
    const request = apiClient
        .get('/screener/documents/latest', {
        responseType: 'blob',
        params: {
            document_type: documentType,
            locale
        },
        headers: {
            Accept: 'application/pdf'
        }
    })
        .then((response) => {
        legalDocumentPdfCache.set(cacheKey, response.data);
        legalDocumentPdfRequests.delete(cacheKey);
        return response.data;
    })
        .catch((error) => {
        legalDocumentPdfRequests.delete(cacheKey);
        throw error;
    });
    legalDocumentPdfRequests.set(cacheKey, request);
    return request;
});
export const getLegalDocumentContent = (documentType_1, ...args_1) => __awaiter(void 0, [documentType_1, ...args_1], void 0, function* (documentType, locale = 'en-US') {
    const cacheKey = `${documentType}:${locale}`;
    const cachedDocument = legalDocumentContentCache.get(cacheKey);
    if (cachedDocument) {
        return cachedDocument;
    }
    const pendingRequest = legalDocumentContentRequests.get(cacheKey);
    if (pendingRequest) {
        return pendingRequest;
    }
    const request = apiClient
        .get('/screener/documents/latest', {
        params: {
            document_type: documentType,
            locale
        },
        headers: {
            Accept: 'application/json'
        }
    })
        .then((response) => {
        legalDocumentContentCache.set(cacheKey, response.data);
        legalDocumentContentRequests.delete(cacheKey);
        return response.data;
    })
        .catch((error) => {
        legalDocumentContentRequests.delete(cacheKey);
        throw error;
    });
    legalDocumentContentRequests.set(cacheKey, request);
    return request;
});
